import * as React from "react";
import {
  Button,
  Stack,
  Flex,
  Box,
  Heading,
  Text,
  VStack,
  HStack,
} from '@chakra-ui/react';
import {
  MdPhone,
  MdEmail,
  MdFacebook,
} from 'react-icons/md';
import { ContactFormForm } from "./ContactFormForm";
import { useState } from "react";

const ContactForm = () => {
  const [successState, setSuccessState] = useState('default');

  const postToBackend = async (obj) => {
    const url = 'https://contact-form-2647-dev.twil.io/send-email';
    // const url = 'http://localhost:3000/send-email';
    const response = await fetch(url, {
      method: 'post',
      body: JSON.stringify(obj),
      headers: {
        "Content-type": 'application/json'
      }
    });
  
    if (response.status === 200) {
      setSuccessState('success');
    }
    if (response.status >= 400) {
      setSuccessState('failure');
    }
  };
  
  
  const handleSubmit = (event) => {
    event.preventDefault();
    const name = document.getElementById('name').value;
    const email = document.getElementById('email').value;
    const message = document.getElementById('message').value;
    const phone = document.getElementById('phone').value;
    const contactObj = {
      name,
      email,
      message,
      phone,
    };
  
    if (window.grecaptcha) {
      window.grecaptcha.execute('6Lc-p1MmAAAAADU_6MWLucA8485bN6c46uzV24NG', {action: 'submit'}).then(function(token) {
        contactObj.token = token;
        postToBackend(contactObj);
      });
    } else {
      postToBackend(contactObj);
    }
    
    console.log(contactObj);
  }

  return (
      <Box
        w='100%'
        bg="#02054B"
        color="white"
        borderRadius={{base: 0, xl : "lg"}}
        px={{ base: 0, sm: 5, lg: 16 }}
        py={{ base: 10, md: 10, lg: 16 }}>
        <Box p={4}>
          <Stack direction={{base: 'column', xl: 'row'}} justify='space-evenly'>
            <Flex flex={1}>
              <Box width={"100%"}>
                <Heading>Contact Us</Heading>
                <Text mt={{ base: 3, sm: 3, lg: 5 }} color="#DCE2FF" fontSize={'18px'}>
                  Fill out the form and we will get back to you ASAP!
                </Text>
                <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }} width={"100%"}>
                  <VStack pl={0} spacing={3} alignItems="flex-start">
                    <Stack direction={'row'} pl={'24px'} pb={'20px'}>
                      <MdPhone style={{marginTop: "2px"}} color="#1970F1" size="24px" />
                      <a href="tel:+18562520870" target='_blank' rel="noopener nofollow noreferrer"><Text fontSize={{base: "16px", sm: "18px", lg: "20px"}} color="#DCE2FF">(856) 252-0870</Text></a>
                    </Stack>
                    <Stack direction={'row'} pl={'24px'} pb={'20px'} width={"100%"}>
                      <MdEmail style={{margin: "auto 0"}} color="#1970F1" size="24px" />
                      <a href="mailto:matt@jamesonmoving.com" target='_blank' rel="noopener nofollow noreferrer"><Text fontSize={{base: "16px", sm: "18px", lg: "20px"}} color="#DCE2FF" width={"100%"}>matt@jamesonmoving.com</Text></a>
                    </Stack>
                  </VStack>
                </Box>
                <HStack
                  mb={{base: 10, md: 20}}
                  spacing={5}
                  px={5}
                  alignItems="flex-start">
                  <a className="facebook_link" target="_blank" rel="noopener nofollow noreferrer" href={'https://www.facebook.com/Jameson-Moving-and-Storage-109999558415876/'}>
                    <Button p={'20px'} variant='solid' leftIcon={<MdFacebook color="#0D74FF" size="20px" />}>
                      <Text fontFamily={'PoppinsMedium, sans-serif'} fontSize={'18px'} color="#0D74FF">Facebook</Text>
                    </Button>
                  </a>
                </HStack>
              </Box>
            </Flex>
            <Flex flex={1}>
              <Box bg="white" borderRadius="lg" w='100%'>
                <Box m={8} color="#0B0E3F">
                  <VStack spacing={5}>
                    {successState === 'default' && <ContactFormForm handleSubmit={handleSubmit}></ContactFormForm>}
                    {successState === 'success' && 
                      <div className="contactform_submitMessage">
                        <div className="contactform_submitText">Thank you for reaching out! We will get back to you as soon as possible!</div>
                        <div>If you do not hear from us within 1 business day, please do not hesitate to call us at</div>
                        <div className="contactform_submitMessage_phone"><a href="tel:+18562520870" target='_blank' rel="noopener nofollow noreferrer">{"(856) 252-0870"}</a></div>
                      </div>
                    }
                    {successState === 'failure' && 
                      <div className="contactform_submitMessage">
                        <div className="contactform_submitText">Sorry, we were unable to process your submission at this time.</div>
                        <div>Please try again or reach out to</div>
                        <div><a className="contactform_submitMessage_phone" href="tel:+18562520870" target='_blank' rel="noopener nofollow noreferrer">{"(856) 252-0870"}</a></div>
                        <div>and we can provide you with an estimate ASAP!</div>
                      </div>
                    }
                  </VStack>
                </Box>
              </Box>
            </Flex>
          </Stack>
        </Box>
      </Box>
  );
};

export default ContactForm;
